import { FileDownloadOutlined, FileUploadOutlined, History } from '@mui/icons-material';
import BackupIcon from '@mui/icons-material/Backup';
import BusinessIcon from '@mui/icons-material/Business';
import EventNoteIcon from '@mui/icons-material/EventNote';
import GroupIcon from '@mui/icons-material/Group';
import { useCallback } from 'react';
import { ENTITY_NAMES } from '../config/entity/entityConfig';

export const useEntityUtils = () => {
    const getEntityIdKey = useCallback((entityName) => {
        switch (entityName) {
            case ENTITY_NAMES.CONTATO:
                return 'cod_contato';
            case ENTITY_NAMES.EMPRESA:
                return 'cod_empresa';
            case ENTITY_NAMES.USUARIO:
                return 'cod_usuario';
            case ENTITY_NAMES.BACKUP:
                return 'cod_backup';
            case ENTITY_NAMES.BACKUP_LOG:
                return 'codBackupLog';
            case ENTITY_NAMES.EXPORTACAO:    
                return 'cod_exportacaolog'
             case ENTITY_NAMES.IMPORTACAO:       
               return 'cod_importacaolog';
            default:
                throw new Error(`Chave primária desconhecida para a entidade: ${entityName}`);
        }
    }, []);

    const getEntityIcon = useCallback((entity) => {
        switch (entity) {
            case ENTITY_NAMES.EMPRESA:
                return <BusinessIcon fontSize="large" sx={{ mr: 1 }} color="primary" />;
            case ENTITY_NAMES.USUARIO:
                return <GroupIcon fontSize="large" sx={{ mr: 1 }} color="primary" />;
            case ENTITY_NAMES.CONTATO:
                return <EventNoteIcon fontSize="large" sx={{ mr: 1 }} color="primary" />;
            case ENTITY_NAMES.BACKUP:
                return <BackupIcon fontSize="large" sx={{ mr: 1 }} color="primary" />;
            case ENTITY_NAMES.BACKUP_LOG:
                return <History fontSize="large" sx={{ mr: 1 }} color="primary" />;
            case ENTITY_NAMES.EXPORTACAO:
                return <FileUploadOutlined fontSize="large" sx={{ mr: 1 }} color="primary" />;
            case ENTITY_NAMES.IMPORTACAO:
                return <FileDownloadOutlined fontSize="large" sx={{ mr: 1 }} color="primary" />;
            default:
                return null;
        }
    }, []);

    const getEntityLabel = useCallback((entity) => {
        switch (entity) {
            case ENTITY_NAMES.CONTATO:
                return 'Contato';
            case ENTITY_NAMES.EMPRESA:
                return 'Empresa';
            case ENTITY_NAMES.USUARIO:
                return 'Usuário';
            case ENTITY_NAMES.BACKUP:
                return 'Backup';
            case ENTITY_NAMES.BACKUP_LOG:
                return 'Log de Backup';
            case ENTITY_NAMES.EXPORTACAO:
                return 'Exportação';
            case ENTITY_NAMES.IMPORTACAO:
                return 'Importação';
            default:
                throw new Error(`Label desconhecida para a entidade: ${entity}`);
        }
    }, []);

    return {
        getEntityIdKey,
        getEntityIcon,
        getEntityLabel
    };
};